// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1PZDm","dragIcon":"Choice_dragIcon__1z0yB","left":"Choice_left__1KiG1","input":"Choice_input__13Zlx"};